import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'eCPM',
    templateUrl: 'eCPM.component.html'
})

export class ECPMComponent implements OnInit {
    @Input() eCpmValue: number;
    @Input() showTopSectionOverlay: boolean;
    
    constructor() { }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/dashboard/eCPM/eCPM.component.ts